import { TDispatch } from 'utils';

export const changeStep = ({
  step,
  direction = 'forward',
  dispatch,
}: {
  step: number;
  direction?: 'forward' | 'back';
  dispatch: TDispatch;
}) => {
  // TODO: add tracking

  dispatch({
    type: 'step',
    value: direction === 'forward' ? step + 1 : step - 1,
  });
};

export const goToStep = ({
  step,
  dispatch,
}: {
  step: number;
  dispatch: TDispatch;
}) => {
  // TODO: add tracking

  dispatch({
    type: 'step',
    value: step,
  });
};
